import { useEffect, useState } from 'react';

export const useMountTransition = (isMounted, unmountDelay = 1000) => {
    const [hasTransitionedIn, setHasTransitionedIn] = useState(false);

    useEffect(() => {
        let timeoutId;

        if(isMounted && !hasTransitionedIn)
            timeoutId = setTimeout(() => setHasTransitionedIn(true), unmountDelay);
        else if(!isMounted && hasTransitionedIn)
            timeoutId = setTimeout(() => setHasTransitionedIn(false), unmountDelay);

        return () => { clearTimeout(timeoutId); };
    }, [unmountDelay, isMounted, hasTransitionedIn]);

    return hasTransitionedIn;
};